import { render, staticRenderFns } from "./DadosExibicao.vue?vue&type=template&id=2edb0912"
import script from "./DadosExibicao.vue?vue&type=script&lang=js"
export * from "./DadosExibicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports